import React, { useContext } from 'react';

import { OSContext } from 'context/OSContext';

import IconPlus from 'icons/icon-plus'

const Hotkey = ({ shiftKey, altKey, modKey, metaKey, keyName, keyCode, withPlus }) => {
    const osContext = useContext(OSContext);

    return (
        <span className="hotkey">
            {
                shiftKey ? (
                    <React.Fragment>
                        <span key="shift" className="hotkey-item">
                            { osContext.keys.shiftKeySymbol ? osContext.keys.shiftKeySymbol : <span className="text-key">{ osContext.keys.shiftKey.toUpperCase() }</span> }
                        </span>

                        {
                            withPlus ? (
                                <span className="hotkey-divider">
                                    <IconPlus />
                                </span>
                            ) : null
                        }
                    </React.Fragment>
                ) : null
            }

            {
                altKey ? (
                    <React.Fragment>
                        <span key="alt" className="hotkey-item">
                            { osContext.keys.altKeySymbol ? osContext.keys.altKeySymbol : <span className="text-key">{ osContext.keys.altKey.toUpperCase() }</span> }
                        </span>

                        {
                            withPlus ? (
                                <span className="hotkey-divider">
                                    <IconPlus />
                                </span>
                            ) : null
                        }
                    </React.Fragment>
                ) : null
            }

            {
                metaKey || modKey ? (
                    <React.Fragment>
                        <span key="meta" className="hotkey-item">
                            { osContext.keys.metaKeySymbol ? osContext.keys.metaKeySymbol : <span className="text-key">{ osContext.keys.metaKey.toUpperCase() }</span> }
                        </span>

                        {
                            withPlus ? (
                                <span className="hotkey-divider">
                                    <IconPlus />
                                </span>
                            ) : null
                        }
                    </React.Fragment>
                ) : null
            }

            <span key="key" className="hotkey-item">{ keyName || String.fromCharCode(keyCode)}</span>
        </span>
    )
}

export default Hotkey;
